(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
        arr2[i] = arr[i];
      }

      return arr2;
    } else {
      return Array.from(arr);
    }
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var Track = function () {
    function Track() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Track);

      // storage for events fired before GTM has loaded.
      this._queue = [];
      // once set to true by `this.checkLoaded`
      this.adiTrackLoaded = false;
      // how long we should wait for GTM to load
      this.loadTimeout = options.loadTimeout || 3000;
      // track each pass at `this.checkLoaded`
      this.loadTimeoutElapsed = options.loadTimeoutElapsed || 0;
      // how often `this.checkLoaded` should run
      this.loadTimeoutElapsedIncrement = options.loadTimeoutElapsedIncrement || 10;
      // start checking!
      this.checkLoaded();
    }

    /**
     * wait for adiTrack to load via GTM then process the queue.
     * @todo add a timeout: https://jira.advance.net/browse/ADITRACK-3
     * @return {void}
     */


    _createClass(Track, [{
      key: 'checkLoaded',
      value: function checkLoaded() {
        var _this = this;

        var timeout = setTimeout(function () {
          // fail first if the GTM load timeout has been reached
          if (_this.loadTimeoutElapsed === _this.loadTimeout) {
            _this.page = noop;
            _this.event = noop;
            clearInterval(timeout);
            return console.log('ADITrack could not be loaded.');
          }

          // grab the GTM injected script tag
          var tag = document.getElementById('adiTrackTag');
          // check the data-loaded attribute of the tag to see if it's loaded or not
          var tagAttrIsSet = tag && typeof tag !== 'undefined' && tag.dataset.loaded === 'true';
          // if tag does not exist or data-attr is not set, re-run the function
          if (tagAttrIsSet) {
            _this.adiTrackLoaded = true;
            return _this.processQueue();
          }

          // otherwise increment `this.loadTimeoutElapsed` by 10ms and re-run
          _this.loadTimeoutElapsed = _this.loadTimeoutElapsed + _this.loadTimeoutElapsedIncrement;
          return _this.checkLoaded();
        }, this.loadTimeoutElapsedIncrement);
      }
    }, {
      key: 'event',
      value: function event(props, config) {
        return !this.adiTrackLoaded ? this._queue.push({ type: 'event', args: [props, config] }) : window._adiTrack.event(props, config);
      }
    }, {
      key: 'page',
      value: function page() {
        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;

        return !this.adiTrackLoaded ? this._queue.push({ type: 'page', args: [url] }) : window._adiTrack.page(url);
      }
    }, {
      key: 'processQueue',
      value: function processQueue() {
        if (isDefined(this._queue) && Array.isArray(this._queue)) {
          this._queue.forEach(function (job, index) {
            if (window._adiTrack[job.type] && isFunction(window._adiTrack[job.type])) {
              var _window$_adiTrack;

              (_window$_adiTrack = window._adiTrack)[job.type].apply(_window$_adiTrack, _toConsumableArray(job.args));
            }
          });
        }
      }
    }]);

    return Track;
  }();

  var noop = function noop() {};

  /**
   * @param {function} fn
   * @return {boolean}
   */
  var isFunction = function isFunction(fn) {
    return fn && typeof fn === 'function';
  };

  /**
   * [isDefined description]
   * @param {mixed} definition
   * @return {boolean}
   */
  var isDefined = function isDefined(definition) {
    return definition && typeof definition !== 'undefined';
  };

  /**
   * This is the default export of the module.
   * If adiTrack is already defined we use that, otherwise,
   * we namespace the module to `window.adiTrack` and once
   * GTM has loaded, it is namespaced to `window._adiTrack`
   * and all method calls are proxied to that namespace.
   * @type {object}
   */
  var _default = null;

  // if adiTrack already exists we'll just use that...
  // otherwise, instantiate the track class and use that.
  if (isDefined(window.adiTrack)) {
    _default = window.adiTrack;
  } else {
    _default = window.adiTrack = new Track();
  }

  // default to the above
  exports.default = _default;
});